import { useRef, useState } from 'react';
import api from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const ImageUrlField = ({ value, onChange, placeholder = 'Image URL (https://...)', testId, uploadPath = '/admin/cms/upload-image' }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await api.post(uploadPath, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(res.data.url);
      toast.success('Image uploaded');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Upload failed');
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div className="flex items-center gap-1">
      {value ? <img src={value} alt="" className="h-7 w-7 rounded object-cover border border-stone/40 shrink-0" /> : null}
      <Input value={value || ''} onChange={e => onChange(e.target.value)} className="h-7 text-xs flex-1" placeholder={placeholder} data-testid={testId} />
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
      <Button type="button" variant="outline" size="sm" className="h-7 text-[10px] gap-1 px-2 shrink-0"
        onClick={() => fileRef.current?.click()} disabled={uploading}
        data-testid={testId ? `${testId}-upload` : undefined}>
        {uploading ? <Loader2 className="h-3 w-3 animate-spin" /> : <Upload className="h-3 w-3" />} Upload
      </Button>
    </div>
  );
};
